var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Alert, Box, IconButton, Stack } from "@mui/material";
import AddPhotoAlternateIcon from '@mui/icons-material/AddPhotoAlternate';
import DeleteIcon from '@mui/icons-material/Delete';
import LandscapeIcon from '@mui/icons-material/Landscape';
import { CloudinaryService } from "../services/cloudinary.service";
import { useState } from "react";
import { getScaledUrl, MediaSize } from "../utils/media.util";
import { CommonThemeColors } from "./theme";
import Button from "@mui/material/Button";
import { useSnackbar } from "notistack";
import { useLocalize } from "../utils/text.util";
import { useReadOnly } from "../utils/hooks/users/useReadOnly";
var ImagePicker = function (_a) {
    var image = _a.image, setImage = _a.setImage, width = _a.width, height = _a.height, id = _a.id, objectFit = _a.objectFit, disabled = _a.disabled, allowedRatios = _a.allowedRatios, previewAspectRatio = _a.previewAspectRatio, hint = _a.hint;
    var _b = useState(null), selectedRatio = _b[0], setSelectedRatio = _b[1];
    // Used for image upload notifications
    var enqueueSnackbar = useSnackbar().enqueueSnackbar;
    var t = useLocalize().t;
    // Read-only users cannot upload or remove images anywhere in the app.
    var readOnly = useReadOnly();
    var isDisabled = disabled || readOnly;
    var handleImageUpload = function () { return __awaiter(void 0, void 0, void 0, function () {
        var validationId, parseRatio, ratioValue;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    validationId = id || 'default-id';
                    parseRatio = function (label) {
                        var _a = label.split(":").map(function (n) { return parseFloat(n); }), w = _a[0], h = _a[1];
                        return h > 0 ? w / h : 1;
                    };
                    ratioValue = selectedRatio ? parseRatio(selectedRatio) : null;
                    return [4 /*yield*/, CloudinaryService.uploadMedia(validationId, __assign(__assign({ cropping: true, croppingCoordinatesMode: "custom", showSkipCropButton: true, croppingShowDimensions: true, croppingValidateDimensions: true, croppingShowBackButton: true }, (ratioValue && { croppingAspectRatio: ratioValue })), { minImageWidth: 500, minImageHeight: 250 })).then(function (uploadedImage) {
                            // Handle successful upload
                            enqueueSnackbar(t("Image uploaded successfully"), { variant: "success" });
                            setImage === null || setImage === void 0 ? void 0 : setImage({
                                mediaURI: uploadedImage.secure_url,
                                publicId: uploadedImage.public_id,
                                provider: 'cloudinary'
                            });
                        })
                            .catch(function (error) {
                            // Handle error
                            // Show user-friendly message
                            if (error.status) {
                                enqueueSnackbar(t(error.status), { variant: "error" });
                            }
                            else {
                                enqueueSnackbar(t("Image upload failed"), { variant: "error" });
                            }
                        })];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); };
    var imageSource = getScaledUrl(image, MediaSize.LARGE_600, MediaSize.LARGE_600);
    var imagePreview;
    if (imageSource) {
        imagePreview = (_jsx("img", { src: imageSource, style: {
                width: "100%",
                height: "100%",
                borderRadius: 8,
                objectFit: objectFit || 'cover',
                backgroundColor: "rgba(0, 0, 0, 0.04)",
                display: "block"
            } }));
    }
    else {
        imagePreview = (_jsx(Box, __assign({ sx: {
                width: width || 230,
                height: height || 230,
                borderRadius: 1,
                backgroundColor: CommonThemeColors.sys.primary.main,
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
            } }, { children: _jsx(LandscapeIcon, { sx: {
                    width: '128px',
                    height: '128px',
                    color: CommonThemeColors.sys.primary.contrastText
                } }) })));
    }
    // Minimal change here ↓
    var aspectRatio = image && previewAspectRatio
        ? (function () {
            var _a = previewAspectRatio.split(":").map(Number), w = _a[0], h = _a[1];
            return w && h ? w / h : undefined;
        })()
        : undefined;
    return (_jsxs(Box, __assign({ id: id, sx: __assign({ position: 'relative', marginBottom: '10px', width: width || 230 }, (aspectRatio
            ? { aspectRatio: aspectRatio }
            : { height: height || 230 })) }, { children: [imagePreview, !isDisabled && (_jsxs(Box, __assign({ sx: {
                    position: 'absolute',
                    bottom: 0,
                    width: '100%',
                    justifyContent: 'center',
                    alignItems: 'center',
                    display: 'flex',
                    gap: 2,
                    background: 'linear-gradient(0deg, rgba(0,0,0,0.7) 0%, rgba(0,0,0,0) 100%)',
                    paddingBottom: '5px',
                    paddingTop: '5px'
                } }, { children: [allowedRatios && allowedRatios.length > 1 ? (_jsx(Stack, __assign({ direction: "row", spacing: 1 }, { children: allowedRatios.map(function (ratio) {
                            var isActive = ratio === selectedRatio;
                            return (_jsx(Button, __assign({ variant: isActive ? "contained" : "outlined", color: isActive ? "secondary" : undefined, sx: {
                                    bgcolor: isActive ? undefined : "#fff",
                                    "&:hover": {
                                        bgcolor: isActive ? undefined : "#ccc",
                                    },
                                }, size: "small", onClick: function () { return setSelectedRatio(ratio); } }, { children: ratio }), ratio));
                        }) }))) : null, _jsx(IconButton, __assign({ onClick: handleImageUpload }, { children: _jsx(AddPhotoAlternateIcon, { sx: {
                                width: "24px",
                                height: "24px",
                                color: CommonThemeColors.sys.primary.contrastText,
                            } }) })), !!image && (_jsx(IconButton, __assign({ onClick: function () { return setImage === null || setImage === void 0 ? void 0 : setImage(undefined); } }, { children: _jsx(DeleteIcon, { sx: {
                                width: '24px',
                                height: '24px',
                                color: CommonThemeColors.sys.primary.contrastText
                            } }) })))] }))), hint && (_jsx(Box, __assign({ sx: { mt: 1 } }, { children: _jsx(Alert, __assign({ severity: "info" }, { children: _jsx(Box, __assign({ sx: { pt: 0.5 } }, { children: hint })) })) })))] })));
};
export default ImagePicker;
